import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

const SectionContainer = styled.div`
  background: white;
  border-radius: 0.75rem;
  border: 1px solid #01010110;
  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.1);
  overflow: hidden;
`;

const SectionHeader = styled.div`
  padding: 1.5rem 2rem;
  background: #f1f1f1;
  border-bottom: 1px solid #01010110;
`;

const SectionTitle = styled.h3`
  font-size: 1.125rem;
  font-weight: 600;
  color: #333333;
  margin: 0;
`;

const SectionContent = styled.div`
  padding: 1.5rem;
`;

const FormGrid = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 1rem;

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
  }
`;

const FormField = styled.div`
  display: flex;
  flex-direction: column;
`;

const Label = styled.label`
  font-size: 0.875rem;
  font-weight: 500;
  color: #333333;
  margin-bottom: 0.25rem;
`;

const Input = styled.input`
  padding: 0.5rem 0.75rem;
  border: 1px solid #01010120;
  border-radius: 0.5rem;
  font-size: 0.875rem;
  background: #f9f9f9;
  color: #333333;
  transition: all 0.2s;

  &:focus {
    outline: none;
    border-color: #00a693;
    box-shadow: 0 0 0 3px rgba(0, 166, 147, 0.1);
    background: white;
  }
`;

const Select = styled.select`
  padding: 0.5rem 0.75rem;
  border: 1px solid #01010120;
  border-radius: 0.5rem;
  font-size: 0.875rem;
  background: #f9f9f9;
  color: #333333;
  transition: all 0.2s;

  &:focus {
    outline: none;
    border-color: #00a693;
    box-shadow: 0 0 0 3px rgba(0, 166, 147, 0.1);
    background: white;
  }
`;

const DisabledOverlay = styled.div`
  position: relative;
  
  &::after {
    content: 'Coming Soon';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.7);
    color: white;
    display: flex;
    align-items: center;
    justify-content: center;
    font-weight: 600;
    border-radius: 0.5rem;
    z-index: 10;
  }
`;

const EventDetailsSection = ({
  isPublic,
  onVisibilityChange,
  discountCode,
  onDiscountCodeChange,
  viewersPrice,
  onViewersPriceChange,
  teamAName,
  teamBName,
  onTeamANameChange,
  onTeamBNameChange
}) => {
  return (
    <SectionContainer>
      <SectionHeader>
        <SectionTitle>Event Details</SectionTitle>
      </SectionHeader>
      <SectionContent>
        <FormGrid>
          <FormField>
            <Label>Visibility</Label>
            <Select
              value={isPublic ? "public" : "private"}
              onChange={(e) => onVisibilityChange(e.target.value === "public")}
            >
              <option value="public">Public (free)</option>
              <option value="private">Private (requires payment)</option>
            </Select>
          </FormField>
          {!isPublic && (
            <FormField>
              <Label>Viewers Price ($)</Label>
              <Input
                type="number"
                value={viewersPrice}
                onChange={(e) => onViewersPriceChange(parseFloat(e.target.value) || 0)}
                placeholder="Enter price for viewers"
                min="0"
                step="0.01"
              />
            </FormField>
          )}
        </FormGrid>

        {!isPublic && (
          <FormField>
            <Label>Discount Code (optional)</Label>
            <Input
              type="text"
              value={discountCode}
              onChange={(e) => onDiscountCodeChange(e.target.value)}
              placeholder="Enter discount code"
            />
          </FormField>
        )}

        <FormGrid>
          <FormField>
            <Label>Team A</Label>
            <DisabledOverlay>
              <Input
                type="text"
                value={teamAName}
                onChange={(e) => onTeamANameChange(e.target.value)}
                placeholder="Enter Team A name"
                disabled
              />
            </DisabledOverlay>
          </FormField>
          <FormField>
            <Label>Team B</Label>
            <DisabledOverlay>
              <Input
                type="text"
                value={teamBName}
                onChange={(e) => onTeamBNameChange(e.target.value)}
                placeholder="Enter Team B name"
                disabled
              />
            </DisabledOverlay>
          </FormField>
        </FormGrid>
      </SectionContent>
    </SectionContainer>
  );
};

EventDetailsSection.propTypes = {
  isPublic: PropTypes.bool.isRequired,
  onVisibilityChange: PropTypes.func.isRequired,
  discountCode: PropTypes.string.isRequired,
  onDiscountCodeChange: PropTypes.func.isRequired,
  viewersPrice: PropTypes.number.isRequired,
  onViewersPriceChange: PropTypes.func.isRequired,
  teamAName: PropTypes.string.isRequired,
  teamBName: PropTypes.string.isRequired,
  onTeamANameChange: PropTypes.func.isRequired,
  onTeamBNameChange: PropTypes.func.isRequired,
};

export default EventDetailsSection; 